import React, { useEffect, useState } from 'react';
import FurnitureNavbar from '../../../components/layout/Nav';
import './clientpayments.scss';
import Button from 'react-bootstrap/Button';
import Image from '../../../assets/product/big-product1.webp';
import Image2 from '../../../assets/product/big-product2.webp';
import withAuth from '../../auth/WithAuth';

const ClientPayments = () => {
  const [payments, setPayments] = useState([]);

  const dummyPayments = [
    {
      id: 'PAY001',
      date: '2025-10-28',
      amount: 45000,
      status: 'Completed',
      method: 'Mpesa',
      thumbnail: Image,
      title: 'Custom Oak Dining Table',
    },
    {
      id: 'PAY002',
      date: '2025-10-30',
      amount: 120000,
      status: 'Pending',
      method: 'Credit Card',
      thumbnail: Image2,
      title: 'Luxury Sofa Set',
    },
  ];

  useEffect(() => {
    setTimeout(() => setPayments(dummyPayments), 800);
  }, []);

  const handlePay = (payment) => {
    alert(`Redirecting to payment gateway for ${payment.title}`);
  };

  return (
    <>
      <FurnitureNavbar />
      <div className="payments-page">
        {/* Hero Section */}
        <section className="payments-hero">
          <div className="hero-content">
            <h1>🧾 My Payments</h1>
            <p>Track all your payments in one place.</p>
          </div>
        </section>

        {/* Payments Grid */}
        <div className="payments-grid container">
          {payments.map((p) => (
            <div className="payment-card" key={p.id}>
              <div className="card-image">
                <img src={p.thumbnail} alt={p.title} />
              </div>
              <div className="card-content">
                <h3>{p.title}</h3>
                <div className="details">
                  <p>
                    <strong>ID:</strong> {p.id}
                  </p>
                  <p>
                    <strong>Date:</strong> {p.date}
                  </p>
                  <p>
                    <strong>Amount:</strong> KSh {p.amount.toLocaleString()}
                  </p>
                  <p>
                    <strong>Status:</strong>{' '}
                    <span className={`status ${p.status.toLowerCase()}`}>
                      {p.status}
                    </span>
                  </p>
                  <p>
                    <strong>Method:</strong> {p.method}
                  </p>
                </div>
                <div className="actions">
                  {p.status === 'Pending' && (
                    <Button className="pay-btn" onClick={() => handlePay(p)}>
                      Pay Now
                    </Button>
                  )}
                  <Button className="download-btn">Download Receipt</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default withAuth(ClientPayments,"client");
